import React from 'react';
import { FormField, Chips } from '@cian/ui-kit';
import { useIsDesktop } from '../../hooks/useIsDesktop';
import { PROGRAMS_OPTIONS } from '../../constants';

interface IProgramsFieldProps {
  value?: string;
  onChange: (value: string) => void;
}

export const ProgramsField: React.FC<IProgramsFieldProps> = ({ value, onChange }) => {
  const isDesktop = useIsDesktop();
  const handleChipClick = (chipValue: string | number | undefined) => {
    if (typeof chipValue === 'string') {
      onChange(chipValue);
    }
  };

  const chipSize = isDesktop ? 'M' : 'S';

  return (
    <FormField label={'Программы'} dataTestId={'field-programs'} withoutMargin>
      <Chips options={PROGRAMS_OPTIONS} value={value ? [value] : []} onChipClick={handleChipClick} size={chipSize} />
    </FormField>
  );
};

ProgramsField.displayName = 'ProgramsField';
